module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("\n    Redeem Voucher\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "bg-blue-grey-100 p-30"
  }, [_c('p', [_vm._v("If you have a redeem voucher code, please enter it below to receive your credit.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitRedeemVoucher($event)
      }
    }
  }, [_c('form-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucherCode),
      expression: "voucherCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Voucher Code"
    },
    domProps: {
      "value": _vm._s(_vm.voucherCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucherCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Redeem")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-453ee00e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/RedeemVoucher.vue
// module id = 528
// module chunks = 1